export enum FormFieldCheckBoxStyles {
  checkbox = 'CHECKBOX',
  switch = 'SWITCH',
}
